/*
 * Actions types
 */
export enum AtividadesType {
  CONTRATO_RESQUEST = '@atividades/CONTRATO_RESQUEST',
  CONTRATO_SUCCESS = '@atividades/CONTRATO_SUCCESS',
  CONTRATO_FAILURE = '@atividades/CONTRATO_FAILURE',
  AREA_RESQUEST = '@atividades/AREA_RESQUEST',
  AREA_SUCCESS = '@atividades/AREA_SUCCESS',
  AREA_FAILURE = '@atividades/AREA_FAILURE',
  MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST = '@atividades/MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST',
  MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS = '@atividades/MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS',
  MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE = '@atividades/MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE',
  GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST = '@atividades/GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_RESQUEST',
  GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_SUCCESS = '@atividades/GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_SUCCESS',
  GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_FAILURE = '@atividades/GET_ORDER_HANDLE_CHANGE_ROWS_PER_PAGE_FAILURE',
  GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST = '@atividades/GET_ORDER_HANDLE_CHANGE_PAGE_RESQUEST',
  GET_ORDER_HANDLE_CHANGE_PAGE_SUCCESS = '@atividades/GET_ORDER_HANDLE_CHANGE_PAGE_SUCCESS',
  GET_ORDER_HANDLE_CHANGE_PAGE_FAILURE = '@atividades/GET_ORDER_HANDLE_CHANGE_PAGE_FAILURE',
  CHANGE_STATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST = '@atividades/CHANGE_STATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST',
  CHANGE_STATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS = '@atividades/CHANGE_STATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS',
  POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST = '@atividades/POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST',
  POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS = '@atividades/POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS',
  POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE = '@atividades/POST_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE',
  UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST = '@atividades/UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST',
  UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS = '@atividades/UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS',
  UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE = '@atividades/UPDATE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE',
  DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST = '@atividades/DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_RESQUEST',
  DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS = '@atividades/DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_SUCCESS',
  DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE = '@atividades/DELETE_MANTER_ATIVIDADE_TRATAMENTO_DADOS_FAILURE',
  CHANGE_INSERT = '@atividades/CHANGE_INSERT',
  RESET_PAGE = '@atividades/RESET_PAGE',
  CLEAN_MODAL = '@atividades/CLEAN_MODAL',
}

/*
 * State Type
 */
export interface AtividadesState {
  readonly data: any;
  readonly areas: any;
  readonly changeInsert: any;
  readonly resetPage: any;
  readonly contato: any;
  readonly cleanModal: number;
  readonly loading: boolean;
  readonly error: boolean;
}
